module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Workspace.8c4e544c.webp";